<script>
    import { onMount } from "svelte";
    import InlineRadio from "../../components/inline-radio.svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import Card from "../components/card.svelte";
    import Modal from "../components/modal.svelte"
    import Message from "../components/message.svelte";
    import DataTable from "../../components/data-table.svelte";
    import HelpIcon from "../components/helpIcon.svelte";
    import Select from "../components/select.svelte";
    import Switch from "../components/switch.svelte";
    import { Classes, Groups } from "./store.js";

    export let mainConfig;
    export let errMsg = '';
    export let staff = [];

    let datatable;
    let classesOrGroups = [];
    let classesOrGroupsWithoutSupervisor=[];
    let showModal = false;
    let showClassesWithoutSupervisorModal=false;
    let yesNoQuestions = [
        { label: "Yes", value: true },
        { label: "No", value: false },
    ];
    let title = mainConfig.classesConfig.providerId == 1 ? "Google Classrooms" : "Microsoft Teams";
    let titleIntext = mainConfig.classesConfig.providerId == 1  ? "classrooms" : "teams";
    let disableAll = false;

    onMount(async() => {
        
        if(($Classes.length == 0 || $Groups.length == 0) && mainConfig.classesConfig.providerId != null)
        {
            let resp = await wrappedFetch(`/api/reports/GetClassAndGroupData`, {
                method: "post",
            });
            
            let data  = await resp.json();
            Classes.set(data.classes);
            Groups.set(data.groups);
        }
        
        disableAll = !mainConfig.accountConfig.syncPupils || !mainConfig.accountConfig.syncStaff;
    });

    $:{
        classesOrGroups = mainConfig.classesConfig.createSubjectClasses? $Classes : $Groups;  
        classesOrGroups=classesOrGroups.filter(c=>c.totalPupil > 0)    
        if(classesOrGroups.length > 0)
        classesOrGroupsWithoutSupervisor=classesOrGroups.filter(c=>c.supervisor == null || c.supervisor == "");
       
    }
    
    const PreviewClassesOrGroups = async () => {    
        showModal = true;
    }

    const SwitchClassroomPause = async () => {
        console.log('blah')
        await wrappedFetch(
            `/api/cloudConfig/PauseClassSync?providerId=${mainConfig.classesConfig.providerId}&isClassSyncPaused=` +
                mainConfig.classesConfig.isClassSyncPaused,
            { method: "post" }
        );
    };
</script>

{#if mainConfig && mainConfig.classesConfig}

{#if disableAll }
    <Message message="To configure {titleIntext}, you must turn on the sync for pupils and staff."></Message>
    <br />
{/if}

<Card disabled={disableAll}>
    <div slot="header">  
        <div class="row">
            <h3 class="col-10" style="{!mainConfig.accountConfig.syncPupils ? 'color: grey;' : 'color: black;'}">
                {title}
            </h3>
            <div class="col-2" style="padding-left:85px; margin-top: 7px;">
                <Switch
                    bind:checked={mainConfig.classesConfig.isClassSyncPaused}
                    label="Pause"
                    on:switch={SwitchClassroomPause}
                    disabled={disableAll || !mainConfig.classesConfig.autoCreateClasses}
                    icon="fa fa-pause"
                    checkedModalHeader="Are you sure you want to pause the {titleIntext} sync?"
                    uncheckedModalHeader="Are you sure you want to resume the {titleIntext} sync?"
                    checkedModalMessage="Pausing the {titleIntext} sync will cause {titleIntext} to not be managed automatically by Nimbus until the sync is resumed."
                    uncheckedModalMessage="Resuming the {titleIntext} sync will cause {titleIntext} to be managed automatically by Nimbus again." />
            </div>
        </div>
    </div>
    
    <div slot="body">

        <div class="form-group">
            <label for="autoClass" style="display:block;" class="{disableAll ? 'labeldisabled' : ''}">
                Create and maintain {title}?
                
            </label>
            <InlineRadio id="autoClass"
                name="create-new-classroom" 
                options={yesNoQuestions}
                bind:value={mainConfig.classesConfig.autoCreateClasses} 
                disabled={disableAll}
            />
        </div>

        <div class="form-group">
            <label id="subjectClass" for="subjectClass" style="display:block;" class="{disableAll || !mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}">
                Which type of class data do you want to use?
                <HelpIcon message="These are the classes imported from your MIS. Please preview the different options to ensure that the class type you require are created." />
            </label>
            <InlineRadio id="subjectClass"
                name="create-class-membership"
                bind:value={mainConfig.classesConfig.createSubjectClasses}
                options={[
                    { label: "Subject classes",  value: true },
                    { label: "Registration classes", value: false },
                ]}
                disabled={disableAll || !mainConfig.classesConfig.autoCreateClasses}
            />
            {#if mainConfig.classesConfig.createSubjectClasses != null && disableAll == false}
            <a 
                class="btn btn-sm btn-grey" 
                data-toggle="modal"
                data-target=".preview" 
                href="javascript:;"
                on:click={PreviewClassesOrGroups}>Preview</a>
            {/if}
            {#if classesOrGroupsWithoutSupervisor.length > 0 && disableAll == false }
            <div class="alert alert-info mt-2" role="alert">
                There are <b><a href="javascript:;" on:click={()=>showClassesWithoutSupervisorModal = true} style="text-decoration: underline;">{classesOrGroupsWithoutSupervisor.length} classes</a></b> of this type that are missing teachers. Please note that {titleIntext} in {#if mainConfig.classesConfig.providerId == 1} Google {:else} Microsoft{/if} can not be created without a teacher, and therefore the sync will not create these particular {titleIntext} until a teacher has been assigned to them on your MIS or you select a default teacher in the option below.  
            </div>
            {/if}
        </div>

        <div class="form-group">
            <label for="addTeacher" style="display:block;" class="{disableAll || !mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}">
                Create {titleIntext} where there is no teacher data?
                <HelpIcon message="Nimbus sync won't create {titleIntext} without a teacher assigned to it. 
                    To avoid this you can choose to add a selected member of staff to such classes by default." />
            </label>
            <InlineRadio id="addTeacher"
                name="add-default-teacher" 
                options={yesNoQuestions}
                bind:value={mainConfig.classesConfig.hasDefaultTeacher} 
                disabled={disableAll || !mainConfig.classesConfig.autoCreateClasses }
            />
        </div>

        {#if mainConfig.classesConfig.hasDefaultTeacher && staff.length > 0 }
        <div class="form-group">
            <label for="Teacher" style="display:block;" class="{disableAll ? 'labeldisabled' : ''}">
                Who do you want to add?
            </label>
            <div class="input-group">
                <Select id="Teacher"
                    bind:selected={mainConfig.classesConfig.teacherPID}
                    items={staff} 
                    value={'personId'} 
                    label='name' 
                    placeholderText='teacher'
                    disabled={disableAll} />
            </div>
        </div>
        {/if}

        {#if mainConfig.groupsConfig.prependGroupsWithDfE}
        <div class="form-group">
            <label for="prependDfE" style="display:block;" class="{disableAll || !mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}">
                Add a prefix to the {#if mainConfig.classesConfig.providerId == 1} classroom {:else} team {/if} names?
                <HelpIcon message="The prefix added will be the same as the one configured for groups." />
            </label>
            <InlineRadio id="prependDfE"
                name="prepend-class-dfe"
                options={yesNoQuestions}
                bind:value={mainConfig.classesConfig.prependClassesWithDfE} 
                disabled={disableAll || !mainConfig.classesConfig.autoCreateClasses}
            />
        </div>
        {/if}

        <div class="form-group">
            <label for="autoClass" style="display:block;" class="{disableAll || !mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}">
                Automatically delete teachers from {titleIntext}?
                <HelpIcon message="Allow Nimbus to automatically delete teachers from cloud that are not in MIS class data" />
            </label>
            <InlineRadio id="autoDelTeachers"
                name="delete-teachers" 
                options={yesNoQuestions}
                bind:value={mainConfig.classesConfig.deleteTeachersFromClass} 
                disabled={disableAll || !mainConfig.classesConfig.autoCreateClasses}
            />
        </div>

        <div class="form-group">
            <label for="autoClass" style="display:block;" class="{disableAll || !mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}">
                Automatically delete pupils from {titleIntext}?
            </label>
            <InlineRadio id="autoDelStudents"
                name="delete-students" 
                options={yesNoQuestions}
                bind:value={mainConfig.classesConfig.deletePupilsFromClass} 
                disabled={disableAll || !mainConfig.classesConfig.autoCreateClasses}
            />
        </div>

        {#if mainConfig.classesConfig.providerId == 3}
        <div class="form-group">
            <label for="assignStaffPolicy" style="display:block;" class="{disableAll || !mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}">
                Automatically assign Teams policy to staff?
                <HelpIcon message="If chosen, Nimbus will automatically assign Education_PrimaryTeacher_RemoteLearning policy package to all staff." />
            </label>
            <InlineRadio id="assignStaffPolicy"
                name="assign-policy-staff" 
                options={yesNoQuestions}
                bind:value={mainConfig.classesConfig.assignTeamsPolicyToStaff} 
                disabled={disableAll || !mainConfig.classesConfig.autoCreateClasses}
            />
        </div>

        <div class="form-group">
            <label for="assignStudentPolicy" style="display:block;" class="{disableAll || !mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}">
                Automatically assign Teams policy to pupils?
                <HelpIcon message="If chosen, Nimbus will automatically assign Education_PrimaryStudent_RemoteLearning policy package to all pupils." />
            </label>
            <InlineRadio id="assignStudentPolicy"
                name="assign-policy-students" 
                options={yesNoQuestions}
                bind:value={mainConfig.classesConfig.assignTeamsPolicyToStudents} 
                disabled={disableAll || !mainConfig.classesConfig.autoCreateClasses}
            />
        </div>
        {/if}

    </div>
</Card>

<Modal {showModal} targetClass="preview" on:close={() => (showModal = false)} on:show={()=>datatable.adjust()}>
    <div slot="header"><h4>Preview {titleIntext} </h4></div>
    <div slot="content">
        <!-- <p style="color: #2E817D;"> <span style="text-transform: capitalize;">{titleIntext}</span> where your default selected teacher will be added.</p> -->
        <DataTable DataLength={classesOrGroups.length} bind:this={datatable} isFixedHeight={true} message="There are currently no classes of this type being imported.">
            <thead>
                <tr>                    
                    <th>Class</th>                                 
                   {#if mainConfig.classesConfig.createSubjectClasses} <th>Subject</th>{/if}
                    <th>Supervisor</th>
                    <th>Pupils</th>
                </tr>
            </thead>
            <tbody>
                {#each classesOrGroups as classes}
                <tr style="color: {!classes.supervisor ? '#2E817D' : ''}">
                    <td>{classes.className || ''}</td>
                    {#if mainConfig.classesConfig.createSubjectClasses}  
                        <td>{classes.subject || ''}</td>   
                    {/if}                    
                    <td>{classes.supervisor || (mainConfig.classesConfig.hasDefaultTeacher ? staff.find(x => x.personId == mainConfig.classesConfig.teacherPID).name : '') } </td>
                    <td>{classes.totalPupil}</td>
                </tr>
                {/each}
            </tbody>
        </DataTable>
            <!-- <h6>Examples of groups/classes that will be created: </h6>
            {#each classesOrGroups as classes}
                 <span style="margin-left: 15px;"> - &nbsp; {classes} </span>
                <br />
            {/each} -->
            
    </div>
</Modal>

{/if}
{#if showClassesWithoutSupervisorModal}
<Modal bind:showModal={showClassesWithoutSupervisorModal} on:show={()=>datatable.adjust()} >
    <div slot="header"><h4>Classes without teachers</h4></div>
    <div slot="content">
        <DataTable DataLength={classesOrGroupsWithoutSupervisor.length} bind:this={datatable} isFixedHeight={true} message="There are currently no classes of this type being imported.">
            <thead>
                <tr>                    
                    <th>Class</th>  
                    <th>Pupils</th>
                </tr>
            </thead>
            <tbody>
                {#each classesOrGroupsWithoutSupervisor as classes}
                <tr>
                    <td>{classes.className || ''}</td>                
                    <td>{classes.totalPupil}</td>
                </tr>
                {/each}
            </tbody>
        </DataTable>
    </div>
</Modal>
{/if}
{#if errMsg != ''}
    <div style="margin-top: 5px;">
        <span style="color:red;">{errMsg}</span>
    </div>
{/if}